import { isDevMode } from "@angular/core";

export const isProduction: boolean = !isDevMode;
